import React from 'react'
import { Link } from "gatsby";

// Styles //
import "./simpleCard.scss";

interface SimpleCardProps {
    title: string;
    image: string;
    theme: string;
    link: string
}

const SimpleCard = (props: SimpleCardProps) => {
    const {title, image, theme, link} = props;

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }
    const isBrowser = typeof window !== "undefined"
    const pathName = isBrowser ? window.location.pathname: ''
    const tituloMultimediaFixed = removeAccents(title).replace(/\s+/g, "").toLowerCase();

    const gtmBasedOnPathName = () =>{
        return `/${pathName.split('/')[2]}/${pathName.split('/')[3]}/` == `/${pathName.split('/')[2]}/biblioteca/` ?
            `gtm_interesar_interna_${pathName.split('/')[2]}_${tituloMultimediaFixed}`
            :'';
    }

    return (
        <Link to={link}>
            <div className={`m-simple-card ${gtmBasedOnPathName()}`}>
                <div className="m-simple-card__image">
                    {image && (
                        <img src={image} alt={title}/>
                    )}
                </div>
                <div className="m-simple-card__text">
                    <span>
                        {theme}
                    </span>
                    <h3>
                        {title}
                    </h3>
                </div>
            </div>
        </Link>
    )
}

export default SimpleCard;